// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--db7ae";
export var problems = "style-module--problems--82d4d";
export var vid = "style-module--vid--1f9e6";